import { connectRefinementList } from "react-instantsearch-dom";
import parse from 'html-react-parser';
import {useTranslation} from "react-i18next";

const RefinementList = ({ values, items, refine }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="checkboxes__items">
      {values.map(staticItem => {

        const { isRefined } = items.find(
            item => item.label === staticItem.label
        ) || {
          isRefined: false,
        };

        const { count } = items.find(
            item => item.label === staticItem.label
        ) || {
          count: 0,
        };

        const btn_label = ()=>{
          if (staticItem.label === 'Manufacturers Suppliers') {
            return t('Directory.ManufacturersSuppliers')
          }
          if (staticItem.label === 'Community Members') {

            let newLabel = t('Directory.Community') + "<br />" + t('Directory.Members');
            return parse(newLabel);
          }
          return t(staticItem.label)
        }

        const btn_helper_txt = ()=>{
          if (staticItem.label === 'Manufacturers Suppliers') {
            return t('Directory.Verified.Partners');
          }
          if (staticItem.label === 'Community Members') {
            return t('Directory.Verified.Education');
          }
          return t('Directory.Verified.Experience');
        }

        return (
        <div className="checkboxes__item" key={staticItem.label}>
          <div className="checkbox-large">
            <input
              type="checkbox"
              id={"checkbox_mt" + staticItem.label}
              checked={isRefined}
              onChange={() => {
                const item = items.find(i => i.label === staticItem.label)
                refine(item.value);
              }}
            />

            <label for={"checkbox_mt" + staticItem.label} className={isRefined && ('checkbox_mt-checked')} >
              <span>{btn_label()}</span>
              {btn_helper_txt()}
              <span className="checkbox__count">{count}</span>
            </label>
          </div>
        </div>
      )}
      )}
    </div>
  );
};

const MembershipRefinement = connectRefinementList(RefinementList);
export default MembershipRefinement;
